import type { FetchTicketResponse } from "src/api/models";
import type { MenuItem } from "../types";

export function createCopyContactMenuItem(
  ticket: FetchTicketResponse,
  handlers: { onCopySuccess: () => void }
): MenuItem {
  const contact = ticket.contact_persons?.[0];
  const phone = contact?.mobile_phone_number ?? contact?.phone_number;

  return {
    label: "Copy Phone",
    icon: "pi pi-phone",
    disabled: !phone,
    command: () => {
      if (!phone) return;
      navigator.clipboard.writeText(phone).then(() => {
        handlers.onCopySuccess();
      }).catch(() => {
        // clipboard write failed (non-secure context or permission denied)
      });
    },
  };
}
